import { render, staticRenderFns } from "./SntExport.vue?vue&type=template&id=e190135a&scoped=true&"
import script from "./SntExport.vue?vue&type=script&lang=js&"
export * from "./SntExport.vue?vue&type=script&lang=js&"
import style0 from "./SntExport.vue?vue&type=style&index=0&id=e190135a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e190135a",
  null
  
)

export default component.exports